import { render, staticRenderFns } from "./HsabTransactions.vue?vue&type=template&id=54b30679"
import script from "./HsabTransactions.vue?vue&type=script&lang=ts"
export * from "./HsabTransactions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports